import { createContext, ReactElement, useContext } from 'react';

export type FieldWrapperFn = (name: string, element: ReactElement) => ReactElement;

// Here we return the element without wrapping it, as a default value
const FieldWrapperContext = createContext<FieldWrapperFn>((_, el) => el);

export const useFieldWrapper = () => useContext(FieldWrapperContext);

export { FieldWrapperContext };
